import { FadeOut } from '@salecycle/ui-component-library';
import { Button, Gap } from '@salecycle/ui-component-library';
import styled from 'styled-components';
import { PropsWithChildren } from 'react';
import { useWorkflowForm } from '../../contexts/CampaignWorkflowFormContext';

const FooterArea = styled.div`
  display: flex;
  align-items: center;
`;

const Grow = styled.div`
  flex-grow: 1;
`;

export interface WorkflowBoxFooterProps {
  show: boolean;
  hasSettingsSet: boolean;
  openConfigurationButtonLabel: string;
  openConfigurationButtonAriaLabel: string;
  onOpenConfiguration: () => void;
  removeGap?: boolean;
}

export const WorkflowBoxFooter = ({
  show,
  hasSettingsSet,
  openConfigurationButtonLabel,
  openConfigurationButtonAriaLabel,
  onOpenConfiguration,
  removeGap,
}: PropsWithChildren<WorkflowBoxFooterProps>) => {
  const { formDisabled } = useWorkflowForm();

  return (
    <>
      {removeGap ? null : <Gap top={16} />}
      <FadeOut out={show}>
        <FooterArea>
          <Grow>
            {!hasSettingsSet && (
              <Button
                aria-label={openConfigurationButtonAriaLabel}
                variation="primary"
                disabled={formDisabled}
                onClick={onOpenConfiguration}
              >
                {openConfigurationButtonLabel}
              </Button>
            )}
          </Grow>
        </FooterArea>
      </FadeOut>
    </>
  );
};
